import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import PlaceOrder from "../../../../components/Orders/Items/PlaceOrder";

const AddNewOrderToSubStore = (props) => {
  const storeName = localStorage.getItem("store_name")
  const store_id = localStorage.getItem("store_id")

  useEffect(() => {
    loadAllStores();
  }, []);

  const [allStores, setAllStores] = useState([]);

  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result2 = response.data.filter((store) =>  store.type === "Sub Store"  && store.name !== storeName)
      setAllStores(result2);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadItems = async (data) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "branchitems/get_sub_store_items";
    const response = await postSubmitForm(url, { sub_store_id:data._id});
    if (response && response.status === 1) {
      const selectOptions = response.data.map(item => ({
        // ...item,
        // item_details:{
          _id:item.item_id,
          name:item.name,
          unit_levels:item.unit_levels,
          available:item.available,
          threshold:item.threshold,
          unit_for_threshold:item.unit_for_threshold,
          category:item.category,
          sub_category:item.sub_category,
        // },
        label: item.name,
        value: item.item_id
      }));
      preloader(false);
      setAllItems(selectOptions);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Orders")}
            alternateTitle={props.t("Items ")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("Add Order")}
          />
         <PlaceOrder 
            allStores={allStores}
            allItems={allItems}
            onStoreSelect={loadItems}
        />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddNewOrderToSubStore))
);

